// extracted by mini-css-extract-plugin
module.exports = {"searchSponsoredProductsContainer":"QV","product":"RV","products":"SV","tooltipWrapper":"TV","tooltip":"UV","title":"VV"};